'use client'

import { joinStr } from '@utils'
import { getComingSoonDateLabel, getSoldLabel, isCommercialData, isEstimateData, isNewhomeData, isOfflineData, isPropertyData, isRentData, isRuralData, isSaleData, isSoldData, isVillageData } from '@utils/house'
import { concat, first, get, size, tail, take } from 'lodash-es'
import { createContext, useContext, useMemo } from 'react'
import { useBoolean } from 'react-use'

export const HouseCoverContext = createContext()
export function useHouseCoverContext() {
  return useContext(HouseCoverContext)
}

export function useHouseCoverState(data) {

  const isForSale = isSaleData(data)
  const isRent = isRentData(data)
  const isSold = isSoldData(data)
  const isProperty = isPropertyData(data)
  const isEstimate = isEstimateData(data)
  const isRural = isRuralData(data)
  const isCommercial = isCommercialData(data)
  const isNewHomes = isNewhomeData(data)
  const isVillage = isVillageData(data)

  const video = useMemo(() => get(data, 'video', null), [data])
  const floorPlanImages = useMemo(() => get(data, 'floorPlanImages', []), [data])
  const imageTagTidy = useMemo(() => get(data, 'imageTagTidy', null), [data])
  const threeD = useMemo(() => get(data, 'threeDview', null), [data])
  const images = get(data, 'images', [])
  const imageSize = size(images)
  const cover = first(images) || (isEstimate ? get(data, 'heroCover') || get(data, 'heroCoverApp') : null)
  const otherImages = take(size(floorPlanImages) > 0 ? concat(first(floorPlanImages), tail(images)) : tail(images), 4)
  const hasOtherImage = size(otherImages) > 0
  const address = joinStr([get(data, 'street', ''), get(data, 'suburb', '')], ' ')
  const soldLabel = getSoldLabel(data)
  const comingSoonLabel = getComingSoonDateLabel(data)

  const showImageBar = (isForSale || isRent || isRural || isCommercial || isNewHomes || isEstimate || isVillage) && !isOfflineData(data)

  const [showMap, toggleShowMap] = useBoolean(imageSize === 0 && get(data, 'lng') && get(data, 'lat'))

  return {
    video,
    floorPlanImages,
    imageTagTidy,
    threeD,
    images,
    imageSize,
    cover,
    otherImages,
    hasOtherImage,
    address,
    isForSale,
    isRent,
    isSold,
    isProperty,
    isEstimate,
    showImageBar,
    soldLabel,
    comingSoonLabel,
    showMap,
    toggleShowMap
  }
}

export default function HouseCoverContent({
  data,
  children
}) {

  const state = useHouseCoverState(data)

  return (
    <HouseCoverContext.Provider value={state}>
      {children}
    </HouseCoverContext.Provider>
  )
}